import { useNavigate } from "react-router-dom";
import { Building2, HardHat } from "lucide-react";
import Logo from "../components/Logo";

export default function Landing() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-[#F4F7F9]">
      <main className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-2xl bg-white shadow-2xl rounded-2xl p-8 md:p-14 border border-slate-100">
          <div className="flex flex-col items-center">
            <Logo size={88} showTagline={false} />

            <h1 className="mt-6 font-display font-semibold text-lg sm:text-xl text-center tracking-tight text-[#1A3A5C]">
              ITCOT Employee Attendance System
            </h1>
          </div>

          <div className="mt-10 space-y-4">
            <button
              data-testid="admin-login-card"
              onClick={() => nav("/admin/login")}
              className="group w-full text-left flex items-center gap-4 bg-[#1A3A5C] hover:bg-[#0F2236] text-white rounded-xl p-5 shadow-md transition-all duration-200 hover:-translate-y-0.5"
            >
              <div className="bg-white/15 rounded-lg p-3">
                <Building2 className="w-7 h-7" />
              </div>
              <div className="flex-1">
                <div className="font-display font-bold text-xl">Admin Login</div>
                <div className="text-white/75 text-sm">
                  System administrators and supervisors
                </div>
              </div>
            </button>

            <button
              data-testid="employee-login-card"
              onClick={() => nav("/employee/login")}
              className="group w-full text-left flex items-center gap-4 bg-[#2A8A8F] hover:bg-[#1C6367] text-white rounded-xl p-5 shadow-md transition-all duration-200 hover:-translate-y-0.5"
            >
              <div className="bg-white/15 rounded-lg p-3">
                <HardHat className="w-7 h-7" />
              </div>
              <div className="flex-1">
                <div className="font-display font-bold text-xl">Employee Login</div>
                <div className="text-white/75 text-sm">
                  Field employees — mark daily attendance
                </div>
              </div>
            </button>
          </div>
        </div>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-4xl mx-auto px-4 py-6 text-center text-sm text-[#475569] space-y-1">
          <p className="font-semibold text-[#1A3A5C]">Owned by ITCOT Limited</p>
          <p>50A, Greams Road, Chennai 600 006</p>
          <p>© 2026 ITCOT Limited | www.itcot.com</p>
        </div>
      </footer>
    </div>
  );
}
